import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import TrustSection from './components/TrustSection';
import CategoriesSection from './components/CategoriesSection';
import WhatIsSection from './components/WhatIsSection';
import WhyUseSection from './components/WhyUseSection';
import ComparisonSection from './components/ComparisonSection';
import FAQSection from './components/FAQSection';
import FinalCtaSection from './components/FinalCtaSection';
import ArticleCardsSection from './components/ArticleCardsSection';

const SITE_URL = import.meta.env.VITE_SITE_URL;

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "CSSBuy Spreadsheet",
  "url": SITE_URL,
  "description": "O melhor CSSBuy Spreadsheet 2026 com produtos verificados, vendedores confiáveis e links atualizados para Brasil e Portugal.",
  "inLanguage": "pt",
  "potentialAction": {
    "@type": "SearchAction",
    "target": `${SITE_URL}/?q={search_term_string}`,
    "query-input": "required name=search_term_string"
  }
};

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "CSSBuySpreadsheet.asia",
  "url": SITE_URL,
  "description": "Recurso independente para o CSSBuy Spreadsheet com produtos, guias e recomendações para compradores brasileiros e portugueses.",
  "logo": `${SITE_URL}/favicon.png`,
  "contactPoint": {
    "@type": "ContactPoint",
    "email": "contato@cssbuyspreadsheet.asia",
    "contactType": "customer service",
    "availableLanguage": ["Portuguese"]
  }
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "O CSSBuy Spreadsheet é gratuito?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim, disponibilizamos o CSSBuy Spreadsheet com links atualizados gratuitamente para toda a comunidade."
      }
    },
    {
      "@type": "Question",
      "name": "Com que frequência o CSSBuy Spreadsheet é atualizado?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Atualizamos nosso CSSBuy Spreadsheet diariamente com novos produtos, vendedores verificados e links confirmados."
      }
    },
    {
      "@type": "Question",
      "name": "O CSSBuy Spreadsheet funciona para o Brasil?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim! O CSSBuy Spreadsheet é totalmente compatível com compradores do Brasil e Portugal."
      }
    },
    {
      "@type": "Question",
      "name": "Como verificar a qualidade dos produtos no CSSBuy Spreadsheet?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Cada produto no CSSBuy Spreadsheet inclui fotos QC verificadas e avaliações da comunidade."
      }
    },
    {
      "@type": "Question",
      "name": "O CSSBuy Spreadsheet inclui marcas como Nike e Jordan?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Sim! O CSSBuy Spreadsheet possui categorias dedicadas para Nike, Jordan, Adidas e outras marcas populares."
      }
    }
  ]
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "CSSBuy Spreadsheet",
      "item": SITE_URL
    }
  ]
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <JsonLd data={faqSchema} />
      <JsonLd data={breadcrumbSchema} />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <TrustSection />
          <CategoriesSection />
          <WhatIsSection />
          <WhyUseSection />
          <ArticleCardsSection />
          <ComparisonSection />
          <FAQSection />
          <FinalCtaSection />
        </article>
      </main>
      <Footer />
    </>
  );
}